import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline'
import type { WaterfallJeStatusValue } from '@/types/waterfall'
import {
  distributionJeRowButtonLabel,
  distributionJeRowButtonTone,
} from './waterfallJeStatus'

type Props = {
  status: WaterfallJeStatusValue | undefined
  loading: boolean
  onClick: () => void
}

export default function DistributionJeRowButton({ status, loading, onClick }: Props) {
  const jeStatus = status ?? 'none'
  const tone = distributionJeRowButtonTone(jeStatus)
  const label = loading ? '…' : distributionJeRowButtonLabel(jeStatus)
  const toneClass =
    tone === 'amber'
      ? 'border-amber-200 bg-amber-50 text-amber-900 hover:bg-amber-100'
      : tone === 'emerald'
        ? 'border-emerald-200 bg-emerald-50 text-emerald-800 hover:bg-emerald-100'
        : 'border-gray-200 bg-white text-gray-700 hover:bg-gray-50'

  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation()
        onClick()
      }}
      disabled={loading}
      aria-label={label}
      className={`inline-flex h-7 min-h-7 max-md:min-h-11 items-center justify-center gap-1 rounded-md border px-2 py-0.5 max-md:py-1 text-[11px] font-medium disabled:opacity-60 ${toneClass}`}
    >
      {label}
      {jeStatus === 'posted' && !loading ? (
        <ArrowTopRightOnSquareIcon className="h-3 w-3 shrink-0" aria-hidden="true" />
      ) : null}
    </button>
  )
}
